// let host = "http://34.219.92.172:8080";
let qahost = "https://api-test.skalebot.com"; //test server
let localhost = "http://localhost:8080"
let prodhost = "https://api.skalebot.com";
 //const baseUrl = qahost + "/api/v1";
 const baseUrl = prodhost  + "/api/v1";

export default baseUrl;
